import { createSlice } from "@reduxjs/toolkit";

const permissionSlice = createSlice({
    name: "permission",
    initialState: {
        userRoles: null,
        data: null,
        rolesPermissions: null,
    },
    reducers: {
        setPermissionConfig: (state, action) => {
            state.userRoles = action.payload.userRoles;
            state.data = action.payload.data;
            state.rolesPermissions = action.payload.rolesPermissions;
        },
    },
});

export const { setPermissionConfig } = permissionSlice.actions;

export default permissionSlice.reducer;
